export const DEVIDER_DETAILS_TYPE_REQUEST = 'DEVIDER_DETAILS_TYPE_REQUEST';
export const DEVIDER_DETAILS_TYPE_SUCCESS = 'DEVIDER_DETAILS_TYPE_SUCCESS';
export const DEVIDER_DETAILS_TYPE_FAIL = 'DEVIDER_DETAILS_TYPE_FAIL';

